import { http } from '@/utils/axios'

/**
 * @msg: 获取课程列表
 */
export function getCourseList(data) {
    return http({
        url: http.baseUrl('elAlbum/getCourseList'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 设置学习时间
 */
 export function setCourseStudyTime(data) {
    return http({
        url: http.baseUrl('elAlbum/setCourseStudyTime'),
        method: 'get',
        params: http.params(data)
    })
}